import {
  AuthenticationCallbackComponent,
  IsAuthenticatedGuard,
  IsLegalDisclaimerAccepted,
} from '@absg/angular-platform';
import { NgModule } from '@angular/core';
import {
  PreloadAllModules,
  RouterModule,
  Routes,
} from '@angular/router';
import { DeviceRegisteredGuard } from 'core.services/device-registered.guard';

import { AuthStartComponent } from './auth-start/auth-start.component';
import { CmsComponent } from './cms/cms.component';
import { DeviceRegistrationComponent } from './device-registration/device-registration.component';
import { HelpCenterComponent } from './help-center/help-center.component';
import { LegalDisclaimerComponent } from './legal-disclaimer/legal-disclaimer.component';
import { LoginComponent } from './login/login.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { LegalDisclaimerResolver } from './shared/services/legal-disclaimer.resolver';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { UnsupportedPlatformComponent } from './unsupported-platform/unsupported-platform.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dispense',
    pathMatch: 'full',
  },
  {
    path: 'register-device',
    canActivate: [IsAuthenticatedGuard],
    component: DeviceRegistrationComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'home',
    component: LoginComponent,
  },
  {
    path: 'legal',
    canActivate: [IsAuthenticatedGuard],
    component: LegalDisclaimerComponent,
    resolve: {
      result: LegalDisclaimerResolver,
    },
  },
  {
    path: 'password-reset',
    component: PasswordResetComponent,
  },
  {
    path: 'dispense',
    loadChildren: () => import('app/dispense/dispense.module').then(m => m.DispenseModule),
    canLoad: [DeviceRegisteredGuard, IsAuthenticatedGuard, IsLegalDisclaimerAccepted],
    data: {
      loginRedirectUrl: '/login',
    },
  },
  {
    path: 'purchase-order',
    loadChildren: () => import('app/purchase-order/purchase-order.module').then(m => m.PurchaseOrderModule),
    canLoad: [IsAuthenticatedGuard],
    data: { loginRedirectUrl: '/login' },
  },
  {
    path: 'inventory',
    loadChildren: () => import('app/inventory/inventory.module').then(m => m.InventoryModule),
    canLoad: [IsAuthenticatedGuard],
    data: { loginRedirectUrl: '/login' },
  },
  {
    path: 'formulary',
    loadChildren: () => import('app/formulary/formulary.module').then(m => m.FormularyModule),
  },
  {
    path: 'station-management',
    loadChildren: () => import('app/station-management/station-management.module').then(m => m.StationManagementModule),
    canLoad: [IsAuthenticatedGuard],
    data: { loginRedirectUrl: '/login' },
  },
  {
    path: 'developer-tools',
    loadChildren: () => import('app/developer-tool/developer-tool.module').then(m => m.DeveloperToolModule),
    canLoad: [IsAuthenticatedGuard],
    data: { loginRedirectUrl: '/login' },
  },
  {
    path: 'authstart',
    component: AuthStartComponent,
  },
  {
    path: 'auth',
    component: AuthenticationCallbackComponent,
    data: { successfulAuthenticationRedirectUrl: '/dispense' },
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
    canActivate: [IsAuthenticatedGuard],
    data: { loginRedirectUrl: '/login' },
  },
  {
    path: 'unsupported',
    component: UnsupportedPlatformComponent,
  },
  {
    path: 'help-center',
    component: HelpCenterComponent,
  },
  {
    path: 'terms-and-conditions',
    component: TermsAndConditionsComponent,
    resolve: {
      result: LegalDisclaimerResolver,
    },
  },
  {
    path: '**',
    component: PageNotFoundComponent,
    canActivate: [IsAuthenticatedGuard],
    data: { loginRedirectUrl: '/login' },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(
    routes,
    {
      preloadingStrategy: PreloadAllModules,
    })],
  exports: [RouterModule],
})
export class MainRoutingModule { }

export const routeComponents = [
  LoginComponent,
  PageNotFoundComponent,
  UnauthorizedComponent,
  UnsupportedPlatformComponent,
  CmsComponent,
];
